import { MeasurementToolsViewModel } from '../measurement-points-admin/model/measurement-points.model';

export class InventorySearchItems {
  constructor(itemPerPage: number) {
    this.PageNumber = 1;
    this.ItemPerPage = itemPerPage;
  }

  public CustomerId: number;
  public JobsiteId: number;
  public EquipmentID: number;
  public MakeId: number;
  public ModelId: number;
  public FamilyId: number;
  public ItemPerPage: number;
  public PageNumber: number;
  public SerialNo: string;
  public ShowBoth: boolean;
  public showRelatedModel: boolean;
  public TypeId: number;
  public InventoryStatusId: number;
  public IncludeWSRE: boolean;
  public ExcludeScrap: boolean;
}

export class ModelCreateInspection {
  public _date: Date;
  public _jobSiteId: number;
  public _systemId: number;
  public _jobNumber: string;
  public _customerRef: string;
  public _oldJobNo: string;
  public _numberOfLinks: number;
  public SystemTypeId: number
  public EqunitId: number;
  //frame
  public TrackFrame_Right_SystemId: number
  public TrackFrame_Customer_L_Serial: string
  public TrackFrame_Customer_R_Serial: string
  public TrackFrameOverallComment_R: string
  public TrackFramOverallRecommendation_R: string
  public FrameSerial_Left: string;
  public FrameSerial_Right: string;
  public FrameInspectedSide: number;
  public StringDate: string;
}

export class ModelCreateInspectionResult {
  public _status: boolean;
  public _inspectionID: number;
  public _message: string;
}


export class SystemsInInventory {
  public systems: SystemsInInventoryViewModel[] = [];
}
export class SystemsInInventoryViewModel {
  public CustomerId: number;
  public CustomerName: string;
  public MakeDesc: string;
  public MakeId: number;
  public ModelId: number;
  public ModelDesc: string;
  public SerialNumber: string;
  public JobSiteId: number;
  public JobsiteName: string;
  public SystemType: number;
  public SystemTypeName: string;
  public TypeFamilyId: number;
  public TypeFamilyName: string;
  public TypeFamilySymbol: string;
  public EvalCondition: string;
  public LTD: number;
  public ActionWasTakenOrNot: string;
  public SystemId: number;
  public SystemNote: string;
  public AverageCMU: number;
  public isWSREEnable: boolean;
  public Components: SystemComponentViewModel[]
  public eqSerial: string;
  public eqUnit: string;
  public Side: string;
  public LifeLived: number;
  public LifeLivedKm: number;
  public TotalComponentPurchaseCost: number;
  public TotalComponentRepairsCost: number;
  public BudgetLife: number;
  public BudgetDistance: number;
  public CastFrame: number;
  public ToeOutFrame: number;
  public SystemCondition: string;
  public SystemConditionColor: string;
  public LinkCMU: number;
  public LinkWorn: number;
  public LinkAction: string;
  public BushCMU: number;
  public BushWorn: number;
  public BushkAction: string;
  public ShoeCMU: number;
  public ShoeWorn: number;
  public IdlerWorn1: number;
  public IdlerWorn2: number;
  public SprocketWorn1: number;
  public TRWorn1: number;
  public TRWorn2: number;
  public TRWorn3: number;
  public TRWorn4: number;
  public TRWorn5: number;
  public TRWorn6: number;
  public TRWorn7: number;
  public TRWorn8: number;
  public CRWorn1: number;
  public CRWorn2: number;
  public CRWorn3: number;
  public LastInspectionDate: Date;
}

export interface InventoryComponentValue {
  ModuleUcsubAuto: number;
  ComponentTypeId: number;
  ComponentName: string;
  PositionNo: number;
  WornPercentage: number;
  CMU: number;
  LastAction: string;
}

export interface InventoryComponentMetadata {
  ComponentTypeId: number;
  ComponentName: string;
  PositionNo: number;
  DisplayName: string;
  DataColumn: string;
  SortOrder: number;
}

export class InventorySystems {
  public isWSREEnable: boolean;
  public TotalRecords: number;
  public ListSystemInventory: SystemsInInventoryViewModel[];
  public InventoryComponentValues: InventoryComponentValue[];
  public InventoryComponentMetadata: InventoryComponentMetadata[];
}



export class SystemComponentViewModel {
  public ComponentId: number;
  public ComponentInInventoryDetailId: number;
  public Name: string;
  public PartNumber: string;
  public CMU: number;
  public MeasurementPoints: number;
  public ToolName: string;
  public ToolId: number;
  public WornPercentage: number;
  public Condition: string;
  public LastestActionName: string;
  public LastestActionDate: Date;
  public TotalCost: number;
  public InititalCost: number;
  public Brand: string;
  public LastestInpsectionId: number = 0;
  public EqunitId: number;
  public CompartId: number;
  public CompartType: number;
  public PossibleTools: MeasurementToolsViewModel[];
  public IsChild: boolean;
  public Budget: number;
  public Comment: string;
  public Pos: number;
  public ImagesCount: number = 0;
  public Images: ImageVM[];
  public DOC: number;
  public DistanceBudget: number;
  public MakeId: number;
  public ComponentName: string;
  public PartCost: number;
  public MiscCost: number;
  public LabourCost: number;
  public FrameCost: number;
  public FrameRepairCost: number;
  public ScreenId: number;
  public Cost: number;
  public AssetNumber: string;
  public JobNumber: string;
  public BushTurnedBudgetLife: number;
  public BushTurnedPercent: number;
  public GrouserId: number;
  public ShoeSize: number;
  public CleanerHolesId: number;
  public MLink: string;
}

export class WSRECreateIdlerVM {
  public SystemId: number;
  public EqunitId: number;
  public side: number;
}

export class ComponentHistoryViewModel {
  public ActionId: number;
  public ComponentName: string;
  public ActionDate: string;
  public ActionName: string;
  public Comment: string;
  public Cost: number;
  public PartCost: number;
  public LabourCost: number;
  public MiscCost: number;
  public HistoryId: number;
}

export class FrameVM {
  public compartid: number
  public srialNo: string
  public side: number
}

export class ImageVM {
  public Id: number
  public Comment: string
  public Image: string
  public ReferenceTableId: number
  public ComponentModel: any
  public ScreenId: number
  public IsEditAddInspection: boolean

}
export class UpdateInventoryCost {
  EqunitId: number;
  PartCost: number;
  LabourCost: number;
  MiscCost: number;
  ScreenId: number;
}
